<script setup lang="ts">
import { useAddRelationPopup } from "@/composable/relation/addRelationPopup";
import { useInteractive } from "@/stores/interactive";
import { MateSprite } from "@/types/game";
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useHouseSession } from "../../store/houseSession";
import HomeInteractiveRelationItem from "@/components/Home/Interactive/HomeInteractiveRelationItem.vue";

const props = defineProps<{
  show: boolean;
}>();
const emit = defineEmits<{
  (e: "update:show", show: boolean): void;
}>();

const houseStore = useHouseSession();
const interactiveStore = useInteractive();
const { t } = useI18n();

const showFilterOc = ref(false);
const filterOptions = computed(() => [
  {
    text: t("house.relationshipPanel.house"),
    value: true,
  },
  {
    text: t("house.relationshipPanel.all"),
    value: false,
  },
]);
const isRelationshipFilterHouse = ref(true);
const { addRelationship } = useAddRelationPopup();
const filterOcList = computed(() => {
  if (isRelationshipFilterHouse.value) {
    return interactiveStore.myRelationshipList.filter(
      (r) =>
        selectedSprites.value.findIndex((s) => s.mateId === r.sourceMateId) !==
          -1 ||
        selectedSprites.value.findIndex((s) => s.mateId === r.targetMateId) !==
          -1
    );
  }
  return interactiveStore.myRelationshipList;
});
const selectedSprites = computed<MateSprite[]>(
  () => houseStore.houseSession?.mateSprites ?? []
);
const onFilterOcConfirm = (value: boolean) => {
  isRelationshipFilterHouse.value = value;
  showFilterOc.value = false;
};
</script>
<template>
  <VanPopup
    :show="props.show"
    @update:show="emit('update:show', $event)"
    class="h-[50%] w-full grid grid-rows-[auto_auto_1fr] bg-base-300 overflow-hidden"
    position="bottom"
    overlay-class="hidden"
  >
    <div class="navbar">
      <div class="navbar-start" />
      <div class="navbar-center">{{ $t("house.relationship") }}</div>
      <div class="navbar-end">
        <button
          class="btn btn-sm btn-ghost btn-square"
          @click="emit('update:show', false)"
        >
          <i class="iconify mingcute--close-line" />
        </button>
      </div>
    </div>
    <div class="h-full overflow-hidden flex flex-col">
      <div class="flex justify-between py-2 px-2">
        <button
          class="btn btn-outline btn-xs line-clamp-1 flex items-center gap-1"
          @click="showFilterOc = true"
        >
          <i class="iconify mingcute--filter-line w-3.5"></i>
          {{
            isRelationshipFilterHouse
              ? $t("house.relationshipPanel.house")
              : $t("house.relationshipPanel.all")
          }}
        </button>
        <button class="btn rounded btn-primary btn-xs" @click="addRelationship">
          {{ $t("interactive.addRelationship") }}
        </button>
      </div>
      <div class="flex flex-col gap-3 h-full overflow-y-auto">
        <HomeInteractiveRelationItem
          v-for="(relationship, index) in filterOcList"
          :key="index"
          :relationship="relationship"
          :is-mine="true"
        />
      </div>
      <ModalSelectOption
        v-model:show="showFilterOc"
        :options="filterOptions"
        @confirm="onFilterOcConfirm"
      />
    </div>
  </VanPopup>
</template>
